import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import LandingPageOne from './components/LandingPageOne';
import LandingPageTwo from './components/LandingPageTwo';
import LandingPageThree from './components/LandingPageThree';
import LandingPageFour from './components/LandingPageFour';
import Layout from './components/Layout';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsConditions from './components/TermsConditions';
import CookiePolicy from './components/CookiePolicy';
import CookieBanner from './components/CookieConsent';
import HomeLander from './components/HomeLander';
import { initFacebookPixel } from './facebookPixel';
import { useEffect } from 'react';
import { saveClickId } from "./redtrack";
import LandingPageFive from './components/LandingPageFive';

function App() {

  useEffect(() => {
    // initFacebookPixel('1266850888742347'); // Prime Circle 
    initFacebookPixel('1066224985837618'); // James BM
    saveClickId();
  }, []);



  return (
    <BrowserRouter>
      {/* Cookie banner renders globally on every route */}
      <CookieBanner />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* <Route path='/' element={<LandingPageOne updateFieldValue={updateFieldValue} form={form} setForm={setForm} did={``} />} /> */}
          {/* <Route path='/' element={<LandingPageOne />} /> */}
          <Route path='/' element={<LandingPageFive />} />
          <Route path='/behind-on-taxes' element={<HomeLander />} />
          {/* Long Form */}
          <Route path='/tax-debt-forgiveness' element={<LandingPageTwo />} />
          {/* TAA Copy */}
          <Route path='/free-consultation' element={<LandingPageThree />} />
          {/* Call Now */}
          <Route path='/call-now' element={<LandingPageFour />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/cookie-policy' element={<CookiePolicy />} />
          <Route path='/terms-conditions' element={<TermsConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
export default App;